import { Map } from "immutable"

import { UNAUTHENTICATED } from "../../actions/action-types"
import { serialiseSearchCriteria } from "./paging-reducer-utils"

const _actionsToHandle = {
    LIST_REQUEST: "",
    LIST_RESPONSE: "",
    LIST_CACHED_RESPONSE: "",
    LIST_ERROR_RESPONSE: ""
}

export default (actionsToHandle = {}, defaultSearchCriteria = Map()) => {
    const defaultState = {
        [serialiseSearchCriteria(defaultSearchCriteria)]: {
            searchCriteria: defaultSearchCriteria
        }
    }
    actionsToHandle = {
        ..._actionsToHandle,
        ...actionsToHandle
    }
    const {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    } = actionsToHandle
    return (state = defaultState, action) => {
        const { type, searchCriteria } = action
        const serialisedSearchCriteria = serialiseSearchCriteria(searchCriteria)
        const previousItemState = state[serialisedSearchCriteria]
        switch (type) {
            case LIST_REQUEST:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: true,
                        isInvalidating: false,
                        searchCriteria
                    }
                }
            case LIST_CACHED_RESPONSE:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false
                    }
                }
            case LIST_RESPONSE:
                const { lastUpdatedAt: previousUpdatedAt } = previousItemState
                const { data, receivedAt } = action
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false,
                        isInvalidating: false,
                        searchCriteria,
                        lastUpdatedAt: receivedAt || previousUpdatedAt,
                        count: data.count
                    }
                }
            case LIST_ERROR_RESPONSE:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false,
                        isInvalidating: false
                    }
                }
            case UNAUTHENTICATED:
                return defaultState
            default:
                return state
        }
    }
}
